<div class="dialog">
    <div class="dialog-header">
        <h2>{{ data.title || ('shared.dialog.alert.heading' | translate) }}</h2>
    </div>
    <div class="dialog-body">
        <p [innerHTML]="data.message | newlines"></p>

        <div class="buttons">
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>

